import axiosInstance from '@/utils/api.js'

var state = {
  paymentSystemsTemplate: [],
  paymentSystems: []
}

var getters = {
  PAYMENT_SYSTEMS_TEMPLATE: (state) => {
    return state.paymentSystemsTemplate
  },
  PAYMENT_SYSTEMS: (state) => {
    return state.paymentSystems
  }
}

var mutations = {
  SET_PAYMENT_SYSTEMS_TEMPLATE: (state, payload) => {
    state.paymentSystemsTemplate = payload
  },
  SET_PAYMENT_SYSTEMS: (state, payload) => {
    state.paymentSystems = payload
  }
}

var actions = {
  GET_PAYMENT_SYSTEMS_TEMPLATE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/payment_systems_template')
    if (result.status === 200) {
      context.commit('SET_PAYMENT_SYSTEMS_TEMPLATE', result.data)
    }
  },
  GET_PAYMENT_SYSTEMS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/payment_systems')
    if (result.status === 200) {
      context.commit('SET_PAYMENT_SYSTEMS', result.data)
    }
  },
  CREATE_PAYMENT_SYSTEMS: (context, payload) => {
    return axiosInstance.post('/settings/payment_systems', payload)
  },
  UPDATE_PAYMENT_SYSTEMS: (context, payload) => {
    return axiosInstance.put('/settings/payment_systems', payload)
  },
  DELETE_PAYMENT_SYSTEMS: (context, payload) => {
    return axiosInstance.delete('/settings/payment_systems?payment_system_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/paymentSystems.js